<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de Gestiones</h4>
        <button type="button" class="btn btn-primary" routerLink="/addManagment">Agregar Gestión</button>
    </div>

    <table *ngIf="listManagments.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listManagments" class="table-active">
            <td>{{ item.name }}</td>
            <td>
                <span *ngIf="item.state === 1" class="text-success">Activo</span>
                <span *ngIf="item.state === 0" class="text-danger">Inactivo</span>
            </td>
            <td>
                <button routerLink="/editManagment/{{ item.id }}" type="button" class="btn btn-info btn-sm">Edit</button>
                <button (click)="deleteManagment(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listManagments.length == 0">No hay gestiones para mostrar</h5>
</div>
